// source: base.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var gameapp_pb = require('./gameapp_pb.js');
goog.object.extend(proto, gameapp_pb);
var audio_pb = require('./audio_pb.js');
goog.object.extend(proto, audio_pb);
var textChat_pb = require('./textChat_pb.js');
goog.object.extend(proto, textChat_pb);
var codingAssistant_pb = require('./codingAssistant_pb.js');
goog.object.extend(proto, codingAssistant_pb);
goog.exportSymbol('proto.base.ActiveUserAudioMeeting', null, global);
goog.exportSymbol('proto.base.LoginAck', null, global);
goog.exportSymbol('proto.base.LoginRequest', null, global);
goog.exportSymbol('proto.base.ResetAck', null, global);
goog.exportSymbol('proto.base.SetProjectContext', null, global);
goog.exportSymbol('proto.base.SetProjectContextAck', null, global);
goog.exportSymbol('proto.base.ToClient', null, global);
goog.exportSymbol('proto.base.ToClient.TypeCase', null, global);
goog.exportSymbol('proto.base.ToServer', null, global);
goog.exportSymbol('proto.base.ToServer.ContentCase', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.ToServer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.base.ToServer.oneofGroups_);
};
goog.inherits(proto.base.ToServer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.ToServer.displayName = 'proto.base.ToServer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.ToClient = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.base.ToClient.oneofGroups_);
};
goog.inherits(proto.base.ToClient, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.ToClient.displayName = 'proto.base.ToClient';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.LoginRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.LoginRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.LoginRequest.displayName = 'proto.base.LoginRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.ActiveUserAudioMeeting = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.ActiveUserAudioMeeting, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.ActiveUserAudioMeeting.displayName = 'proto.base.ActiveUserAudioMeeting';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.LoginAck = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.base.LoginAck.repeatedFields_, null);
};
goog.inherits(proto.base.LoginAck, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.LoginAck.displayName = 'proto.base.LoginAck';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.ResetAck = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.ResetAck, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.ResetAck.displayName = 'proto.base.ResetAck';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.SetProjectContext = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.SetProjectContext, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.SetProjectContext.displayName = 'proto.base.SetProjectContext';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.SetProjectContextAck = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.SetProjectContextAck, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.SetProjectContextAck.displayName = 'proto.base.SetProjectContextAck';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.base.ToServer.oneofGroups_ = [[1,2,3,10,11,12,13]];

/**
 * @enum {number}
 */
proto.base.ToServer.ContentCase = {
  CONTENT_NOT_SET: 0,
  LOGIN: 1,
  RESET: 2,
  SET_PROJECT: 3,
  GAME_MSG: 10,
  AUDIO_MSG: 11,
  TEXT_CHAT_MSG: 12,
  CODING_MSG: 13
};

/**
 * @return {proto.base.ToServer.ContentCase}
 */
proto.base.ToServer.prototype.getContentCase = function() {
  return /** @type {proto.base.ToServer.ContentCase} */(jspb.Message.computeOneofCase(this, proto.base.ToServer.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.ToServer.prototype.toObject = function(opt_includeInstance) {
  return proto.base.ToServer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.ToServer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.ToServer.toObject = function(includeInstance, msg) {
  var f, obj = {
    login: (f = msg.getLogin()) && proto.base.LoginRequest.toObject(includeInstance, f),
    reset: jspb.Message.getFieldWithDefault(msg, 2, ""),
    setProject: (f = msg.getSetProject()) && proto.base.SetProjectContext.toObject(includeInstance, f),
    gameMsg: (f = msg.getGameMsg()) && gameapp_pb.ToGameAppServer.toObject(includeInstance, f),
    audioMsg: (f = msg.getAudioMsg()) && audio_pb.ToAudioServer.toObject(includeInstance, f),
    textChatMsg: (f = msg.getTextChatMsg()) && textChat_pb.ToTextChatServer.toObject(includeInstance, f),
    codingMsg: (f = msg.getCodingMsg()) && codingAssistant_pb.ToCodeAssistServer.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.ToServer}
 */
proto.base.ToServer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.ToServer;
  return proto.base.ToServer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.ToServer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.ToServer}
 */
proto.base.ToServer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.base.LoginRequest;
      reader.readMessage(value,proto.base.LoginRequest.deserializeBinaryFromReader);
      msg.setLogin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setReset(value);
      break;
    case 3:
      var value = new proto.base.SetProjectContext;
      reader.readMessage(value,proto.base.SetProjectContext.deserializeBinaryFromReader);
      msg.setSetProject(value);
      break;
    case 10:
      var value = new gameapp_pb.ToGameAppServer;
      reader.readMessage(value,gameapp_pb.ToGameAppServer.deserializeBinaryFromReader);
      msg.setGameMsg(value);
      break;
    case 11:
      var value = new audio_pb.ToAudioServer;
      reader.readMessage(value,audio_pb.ToAudioServer.deserializeBinaryFromReader);
      msg.setAudioMsg(value);
      break;
    case 12:
      var value = new textChat_pb.ToTextChatServer;
      reader.readMessage(value,textChat_pb.ToTextChatServer.deserializeBinaryFromReader);
      msg.setTextChatMsg(value);
      break;
    case 13:
      var value = new codingAssistant_pb.ToCodeAssistServer;
      reader.readMessage(value,codingAssistant_pb.ToCodeAssistServer.deserializeBinaryFromReader);
      msg.setCodingMsg(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.ToServer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.ToServer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.ToServer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.ToServer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLogin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.base.LoginRequest.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSetProject();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.base.SetProjectContext.serializeBinaryToWriter
    );
  }
  f = message.getGameMsg();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      gameapp_pb.ToGameAppServer.serializeBinaryToWriter
    );
  }
  f = message.getAudioMsg();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      audio_pb.ToAudioServer.serializeBinaryToWriter
    );
  }
  f = message.getTextChatMsg();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      textChat_pb.ToTextChatServer.serializeBinaryToWriter
    );
  }
  f = message.getCodingMsg();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      codingAssistant_pb.ToCodeAssistServer.serializeBinaryToWriter
    );
  }
};


/**
 * optional LoginRequest login = 1;
 * @return {?proto.base.LoginRequest}
 */
proto.base.ToServer.prototype.getLogin = function() {
  return /** @type{?proto.base.LoginRequest} */ (
    jspb.Message.getWrapperField(this, proto.base.LoginRequest, 1));
};


/**
 * @param {?proto.base.LoginRequest|undefined} value
 * @return {!proto.base.ToServer} returns this
*/
proto.base.ToServer.prototype.setLogin = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.base.ToServer.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.ToServer} returns this
 */
proto.base.ToServer.prototype.clearLogin = function() {
  return this.setLogin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.ToServer.prototype.hasLogin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string reset = 2;
 * @return {string}
 */
proto.base.ToServer.prototype.getReset = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.ToServer} returns this
 */
proto.base.ToServer.prototype.setReset = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.base.ToServer.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.base.ToServer} returns this
 */
proto.base.ToServer.prototype.clearReset = function() {
  return jspb.Message.setOneofField(this, 2, proto.base.ToServer.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.ToServer.prototype.hasReset = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional SetProjectContext set_project = 3;
 * @return {?proto.base.SetProjectContext}
 */
proto.base.ToServer.prototype.getSetProject = function() {
  return /** @type{?proto.base.SetProjectContext} */ (
    jspb.Message.getWrapperField(this, proto.base.SetProjectContext, 3));
};


/**
 * @param {?proto.base.SetProjectContext|undefined} value
 * @return {!proto.base.ToServer} returns this
*/
proto.base.ToServer.prototype.setSetProject = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.base.ToServer.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.ToServer} returns this
 */
proto.base.ToServer.prototype.clearSetProject = function() {
  return this.setSetProject(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.ToServer.prototype.hasSetProject = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional gameapp.ToGameAppServer game_msg = 10;
 * @return {?proto.gameapp.ToGameAppServer}
 */
proto.base.ToServer.prototype.getGameMsg = function() {
  return /** @type{?proto.gameapp.ToGameAppServer} */ (
    jspb.Message.getWrapperField(this, gameapp_pb.ToGameAppServer, 10));
};


/**
 * @param {?proto.gameapp.ToGameAppServer|undefined} value
 * @return {!proto.base.ToServer} returns this
*/
proto.base.ToServer.prototype.setGameMsg = function(value) {
  return jspb.Message.setOneofWrapperField(this, 10, proto.base.ToServer.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.ToServer} returns this
 */
proto.base.ToServer.prototype.clearGameMsg = function() {
  return this.setGameMsg(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.ToServer.prototype.hasGameMsg = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional audio.ToAudioServer audio_msg = 11;
 * @return {?proto.audio.ToAudioServer}
 */
proto.base.ToServer.prototype.getAudioMsg = function() {
  return /** @type{?proto.audio.ToAudioServer} */ (
    jspb.Message.getWrapperField(this, audio_pb.ToAudioServer, 11));
};


/**
 * @param {?proto.audio.ToAudioServer|undefined} value
 * @return {!proto.base.ToServer} returns this
*/
proto.base.ToServer.prototype.setAudioMsg = function(value) {
  return jspb.Message.setOneofWrapperField(this, 11, proto.base.ToServer.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.ToServer} returns this
 */
proto.base.ToServer.prototype.clearAudioMsg = function() {
  return this.setAudioMsg(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.ToServer.prototype.hasAudioMsg = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional textChat.ToTextChatServer text_chat_msg = 12;
 * @return {?proto.textChat.ToTextChatServer}
 */
proto.base.ToServer.prototype.getTextChatMsg = function() {
  return /** @type{?proto.textChat.ToTextChatServer} */ (
    jspb.Message.getWrapperField(this, textChat_pb.ToTextChatServer, 12));
};


/**
 * @param {?proto.textChat.ToTextChatServer|undefined} value
 * @return {!proto.base.ToServer} returns this
*/
proto.base.ToServer.prototype.setTextChatMsg = function(value) {
  return jspb.Message.setOneofWrapperField(this, 12, proto.base.ToServer.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.ToServer} returns this
 */
proto.base.ToServer.prototype.clearTextChatMsg = function() {
  return this.setTextChatMsg(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.ToServer.prototype.hasTextChatMsg = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional codingAssistant.ToCodeAssistServer coding_msg = 13;
 * @return {?proto.codingAssistant.ToCodeAssistServer}
 */
proto.base.ToServer.prototype.getCodingMsg = function() {
  return /** @type{?proto.codingAssistant.ToCodeAssistServer} */ (
    jspb.Message.getWrapperField(this, codingAssistant_pb.ToCodeAssistServer, 13));
};


/**
 * @param {?proto.codingAssistant.ToCodeAssistServer|undefined} value
 * @return {!proto.base.ToServer} returns this
*/
proto.base.ToServer.prototype.setCodingMsg = function(value) {
  return jspb.Message.setOneofWrapperField(this, 13, proto.base.ToServer.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.ToServer} returns this
 */
proto.base.ToServer.prototype.clearCodingMsg = function() {
  return this.setCodingMsg(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.ToServer.prototype.hasCodingMsg = function() {
  return jspb.Message.getField(this, 13) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.base.ToClient.oneofGroups_ = [[1,2,3,10,11,12,13]];

/**
 * @enum {number}
 */
proto.base.ToClient.TypeCase = {
  TYPE_NOT_SET: 0,
  LOGIN_ACK: 1,
  RESET_ACK: 2,
  SET_PROJECT_ACK: 3,
  GAME_MSG: 10,
  AUDIO_MSG: 11,
  TEXT_CHAT_MSG: 12,
  CODING_MSG: 13
};

/**
 * @return {proto.base.ToClient.TypeCase}
 */
proto.base.ToClient.prototype.getTypeCase = function() {
  return /** @type {proto.base.ToClient.TypeCase} */(jspb.Message.computeOneofCase(this, proto.base.ToClient.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.ToClient.prototype.toObject = function(opt_includeInstance) {
  return proto.base.ToClient.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.ToClient} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.ToClient.toObject = function(includeInstance, msg) {
  var f, obj = {
    loginAck: (f = msg.getLoginAck()) && proto.base.LoginAck.toObject(includeInstance, f),
    resetAck: (f = msg.getResetAck()) && proto.base.ResetAck.toObject(includeInstance, f),
    setProjectAck: (f = msg.getSetProjectAck()) && proto.base.SetProjectContextAck.toObject(includeInstance, f),
    gameMsg: (f = msg.getGameMsg()) && gameapp_pb.ToGameAppClient.toObject(includeInstance, f),
    audioMsg: (f = msg.getAudioMsg()) && audio_pb.ToAudioClient.toObject(includeInstance, f),
    textChatMsg: (f = msg.getTextChatMsg()) && textChat_pb.ToTextChatClient.toObject(includeInstance, f),
    codingMsg: (f = msg.getCodingMsg()) && codingAssistant_pb.ToCodeAssistClient.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.ToClient}
 */
proto.base.ToClient.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.ToClient;
  return proto.base.ToClient.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.ToClient} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.ToClient}
 */
proto.base.ToClient.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.base.LoginAck;
      reader.readMessage(value,proto.base.LoginAck.deserializeBinaryFromReader);
      msg.setLoginAck(value);
      break;
    case 2:
      var value = new proto.base.ResetAck;
      reader.readMessage(value,proto.base.ResetAck.deserializeBinaryFromReader);
      msg.setResetAck(value);
      break;
    case 3:
      var value = new proto.base.SetProjectContextAck;
      reader.readMessage(value,proto.base.SetProjectContextAck.deserializeBinaryFromReader);
      msg.setSetProjectAck(value);
      break;
    case 10:
      var value = new gameapp_pb.ToGameAppClient;
      reader.readMessage(value,gameapp_pb.ToGameAppClient.deserializeBinaryFromReader);
      msg.setGameMsg(value);
      break;
    case 11:
      var value = new audio_pb.ToAudioClient;
      reader.readMessage(value,audio_pb.ToAudioClient.deserializeBinaryFromReader);
      msg.setAudioMsg(value);
      break;
    case 12:
      var value = new textChat_pb.ToTextChatClient;
      reader.readMessage(value,textChat_pb.ToTextChatClient.deserializeBinaryFromReader);
      msg.setTextChatMsg(value);
      break;
    case 13:
      var value = new codingAssistant_pb.ToCodeAssistClient;
      reader.readMessage(value,codingAssistant_pb.ToCodeAssistClient.deserializeBinaryFromReader);
      msg.setCodingMsg(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.ToClient.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.ToClient.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.ToClient} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.ToClient.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLoginAck();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.base.LoginAck.serializeBinaryToWriter
    );
  }
  f = message.getResetAck();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.base.ResetAck.serializeBinaryToWriter
    );
  }
  f = message.getSetProjectAck();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.base.SetProjectContextAck.serializeBinaryToWriter
    );
  }
  f = message.getGameMsg();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      gameapp_pb.ToGameAppClient.serializeBinaryToWriter
    );
  }
  f = message.getAudioMsg();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      audio_pb.ToAudioClient.serializeBinaryToWriter
    );
  }
  f = message.getTextChatMsg();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      textChat_pb.ToTextChatClient.serializeBinaryToWriter
    );
  }
  f = message.getCodingMsg();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      codingAssistant_pb.ToCodeAssistClient.serializeBinaryToWriter
    );
  }
};


/**
 * optional LoginAck login_ack = 1;
 * @return {?proto.base.LoginAck}
 */
proto.base.ToClient.prototype.getLoginAck = function() {
  return /** @type{?proto.base.LoginAck} */ (
    jspb.Message.getWrapperField(this, proto.base.LoginAck, 1));
};


/**
 * @param {?proto.base.LoginAck|undefined} value
 * @return {!proto.base.ToClient} returns this
*/
proto.base.ToClient.prototype.setLoginAck = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.base.ToClient.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.ToClient} returns this
 */
proto.base.ToClient.prototype.clearLoginAck = function() {
  return this.setLoginAck(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.ToClient.prototype.hasLoginAck = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ResetAck reset_ack = 2;
 * @return {?proto.base.ResetAck}
 */
proto.base.ToClient.prototype.getResetAck = function() {
  return /** @type{?proto.base.ResetAck} */ (
    jspb.Message.getWrapperField(this, proto.base.ResetAck, 2));
};


/**
 * @param {?proto.base.ResetAck|undefined} value
 * @return {!proto.base.ToClient} returns this
*/
proto.base.ToClient.prototype.setResetAck = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.base.ToClient.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.ToClient} returns this
 */
proto.base.ToClient.prototype.clearResetAck = function() {
  return this.setResetAck(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.ToClient.prototype.hasResetAck = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional SetProjectContextAck set_project_ack = 3;
 * @return {?proto.base.SetProjectContextAck}
 */
proto.base.ToClient.prototype.getSetProjectAck = function() {
  return /** @type{?proto.base.SetProjectContextAck} */ (
    jspb.Message.getWrapperField(this, proto.base.SetProjectContextAck, 3));
};


/**
 * @param {?proto.base.SetProjectContextAck|undefined} value
 * @return {!proto.base.ToClient} returns this
*/
proto.base.ToClient.prototype.setSetProjectAck = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.base.ToClient.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.ToClient} returns this
 */
proto.base.ToClient.prototype.clearSetProjectAck = function() {
  return this.setSetProjectAck(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.ToClient.prototype.hasSetProjectAck = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional gameapp.ToGameAppClient game_msg = 10;
 * @return {?proto.gameapp.ToGameAppClient}
 */
proto.base.ToClient.prototype.getGameMsg = function() {
  return /** @type{?proto.gameapp.ToGameAppClient} */ (
    jspb.Message.getWrapperField(this, gameapp_pb.ToGameAppClient, 10));
};


/**
 * @param {?proto.gameapp.ToGameAppClient|undefined} value
 * @return {!proto.base.ToClient} returns this
*/
proto.base.ToClient.prototype.setGameMsg = function(value) {
  return jspb.Message.setOneofWrapperField(this, 10, proto.base.ToClient.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.ToClient} returns this
 */
proto.base.ToClient.prototype.clearGameMsg = function() {
  return this.setGameMsg(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.ToClient.prototype.hasGameMsg = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional audio.ToAudioClient audio_msg = 11;
 * @return {?proto.audio.ToAudioClient}
 */
proto.base.ToClient.prototype.getAudioMsg = function() {
  return /** @type{?proto.audio.ToAudioClient} */ (
    jspb.Message.getWrapperField(this, audio_pb.ToAudioClient, 11));
};


/**
 * @param {?proto.audio.ToAudioClient|undefined} value
 * @return {!proto.base.ToClient} returns this
*/
proto.base.ToClient.prototype.setAudioMsg = function(value) {
  return jspb.Message.setOneofWrapperField(this, 11, proto.base.ToClient.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.ToClient} returns this
 */
proto.base.ToClient.prototype.clearAudioMsg = function() {
  return this.setAudioMsg(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.ToClient.prototype.hasAudioMsg = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional textChat.ToTextChatClient text_chat_msg = 12;
 * @return {?proto.textChat.ToTextChatClient}
 */
proto.base.ToClient.prototype.getTextChatMsg = function() {
  return /** @type{?proto.textChat.ToTextChatClient} */ (
    jspb.Message.getWrapperField(this, textChat_pb.ToTextChatClient, 12));
};


/**
 * @param {?proto.textChat.ToTextChatClient|undefined} value
 * @return {!proto.base.ToClient} returns this
*/
proto.base.ToClient.prototype.setTextChatMsg = function(value) {
  return jspb.Message.setOneofWrapperField(this, 12, proto.base.ToClient.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.ToClient} returns this
 */
proto.base.ToClient.prototype.clearTextChatMsg = function() {
  return this.setTextChatMsg(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.ToClient.prototype.hasTextChatMsg = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional codingAssistant.ToCodeAssistClient coding_msg = 13;
 * @return {?proto.codingAssistant.ToCodeAssistClient}
 */
proto.base.ToClient.prototype.getCodingMsg = function() {
  return /** @type{?proto.codingAssistant.ToCodeAssistClient} */ (
    jspb.Message.getWrapperField(this, codingAssistant_pb.ToCodeAssistClient, 13));
};


/**
 * @param {?proto.codingAssistant.ToCodeAssistClient|undefined} value
 * @return {!proto.base.ToClient} returns this
*/
proto.base.ToClient.prototype.setCodingMsg = function(value) {
  return jspb.Message.setOneofWrapperField(this, 13, proto.base.ToClient.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.ToClient} returns this
 */
proto.base.ToClient.prototype.clearCodingMsg = function() {
  return this.setCodingMsg(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.ToClient.prototype.hasCodingMsg = function() {
  return jspb.Message.getField(this, 13) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.LoginRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.base.LoginRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.LoginRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.LoginRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    token: jspb.Message.getFieldWithDefault(msg, 1, ""),
    openaiApiKey: jspb.Message.getFieldWithDefault(msg, 2, ""),
    chatModel: jspb.Message.getFieldWithDefault(msg, 3, ""),
    realtimeModel: jspb.Message.getFieldWithDefault(msg, 4, ""),
    creqId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    clientType: jspb.Message.getFieldWithDefault(msg, 6, ""),
    clientAppName: jspb.Message.getFieldWithDefault(msg, 7, ""),
    sessionId: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.LoginRequest}
 */
proto.base.LoginRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.LoginRequest;
  return proto.base.LoginRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.LoginRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.LoginRequest}
 */
proto.base.LoginRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOpenaiApiKey(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setChatModel(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRealtimeModel(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreqId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientType(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientAppName(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.LoginRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.LoginRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.LoginRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.LoginRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOpenaiApiKey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getChatModel();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRealtimeModel();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCreqId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getClientType();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getClientAppName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getSessionId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional string token = 1;
 * @return {string}
 */
proto.base.LoginRequest.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.LoginRequest} returns this
 */
proto.base.LoginRequest.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string openai_api_key = 2;
 * @return {string}
 */
proto.base.LoginRequest.prototype.getOpenaiApiKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.LoginRequest} returns this
 */
proto.base.LoginRequest.prototype.setOpenaiApiKey = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string chat_model = 3;
 * @return {string}
 */
proto.base.LoginRequest.prototype.getChatModel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.LoginRequest} returns this
 */
proto.base.LoginRequest.prototype.setChatModel = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string realtime_model = 4;
 * @return {string}
 */
proto.base.LoginRequest.prototype.getRealtimeModel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.LoginRequest} returns this
 */
proto.base.LoginRequest.prototype.setRealtimeModel = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string creq_id = 5;
 * @return {string}
 */
proto.base.LoginRequest.prototype.getCreqId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.LoginRequest} returns this
 */
proto.base.LoginRequest.prototype.setCreqId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string client_type = 6;
 * @return {string}
 */
proto.base.LoginRequest.prototype.getClientType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.LoginRequest} returns this
 */
proto.base.LoginRequest.prototype.setClientType = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string client_app_name = 7;
 * @return {string}
 */
proto.base.LoginRequest.prototype.getClientAppName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.LoginRequest} returns this
 */
proto.base.LoginRequest.prototype.setClientAppName = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string session_id = 8;
 * @return {string}
 */
proto.base.LoginRequest.prototype.getSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.LoginRequest} returns this
 */
proto.base.LoginRequest.prototype.setSessionId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.ActiveUserAudioMeeting.prototype.toObject = function(opt_includeInstance) {
  return proto.base.ActiveUserAudioMeeting.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.ActiveUserAudioMeeting} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.ActiveUserAudioMeeting.toObject = function(includeInstance, msg) {
  var f, obj = {
    description: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userAudioMeetingId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    feRoute: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.ActiveUserAudioMeeting}
 */
proto.base.ActiveUserAudioMeeting.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.ActiveUserAudioMeeting;
  return proto.base.ActiveUserAudioMeeting.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.ActiveUserAudioMeeting} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.ActiveUserAudioMeeting}
 */
proto.base.ActiveUserAudioMeeting.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserAudioMeetingId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFeRoute(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.ActiveUserAudioMeeting.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.ActiveUserAudioMeeting.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.ActiveUserAudioMeeting} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.ActiveUserAudioMeeting.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserAudioMeetingId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFeRoute();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string description = 1;
 * @return {string}
 */
proto.base.ActiveUserAudioMeeting.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.ActiveUserAudioMeeting} returns this
 */
proto.base.ActiveUserAudioMeeting.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_audio_meeting_id = 2;
 * @return {string}
 */
proto.base.ActiveUserAudioMeeting.prototype.getUserAudioMeetingId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.ActiveUserAudioMeeting} returns this
 */
proto.base.ActiveUserAudioMeeting.prototype.setUserAudioMeetingId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string fe_route = 3;
 * @return {string}
 */
proto.base.ActiveUserAudioMeeting.prototype.getFeRoute = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.ActiveUserAudioMeeting} returns this
 */
proto.base.ActiveUserAudioMeeting.prototype.setFeRoute = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.base.LoginAck.repeatedFields_ = [4,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.LoginAck.prototype.toObject = function(opt_includeInstance) {
  return proto.base.LoginAck.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.LoginAck} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.LoginAck.toObject = function(includeInstance, msg) {
  var f, obj = {
    creqId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    error: jspb.Message.getFieldWithDefault(msg, 2, ""),
    appName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    activeUserAudioMeetingsList: jspb.Message.toObjectList(msg.getActiveUserAudioMeetingsList(),
    proto.base.ActiveUserAudioMeeting.toObject, includeInstance),
    webAdminMode: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    featureFlagsList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.LoginAck}
 */
proto.base.LoginAck.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.LoginAck;
  return proto.base.LoginAck.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.LoginAck} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.LoginAck}
 */
proto.base.LoginAck.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreqId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setError(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppName(value);
      break;
    case 4:
      var value = new proto.base.ActiveUserAudioMeeting;
      reader.readMessage(value,proto.base.ActiveUserAudioMeeting.deserializeBinaryFromReader);
      msg.addActiveUserAudioMeetings(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setWebAdminMode(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addFeatureFlags(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.LoginAck.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.LoginAck.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.LoginAck} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.LoginAck.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCreqId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAppName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getActiveUserAudioMeetingsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.base.ActiveUserAudioMeeting.serializeBinaryToWriter
    );
  }
  f = message.getWebAdminMode();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getFeatureFlagsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
};


/**
 * optional string creq_id = 1;
 * @return {string}
 */
proto.base.LoginAck.prototype.getCreqId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.LoginAck} returns this
 */
proto.base.LoginAck.prototype.setCreqId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string error = 2;
 * @return {string}
 */
proto.base.LoginAck.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.LoginAck} returns this
 */
proto.base.LoginAck.prototype.setError = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string app_name = 3;
 * @return {string}
 */
proto.base.LoginAck.prototype.getAppName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.LoginAck} returns this
 */
proto.base.LoginAck.prototype.setAppName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated ActiveUserAudioMeeting active_user_audio_meetings = 4;
 * @return {!Array<!proto.base.ActiveUserAudioMeeting>}
 */
proto.base.LoginAck.prototype.getActiveUserAudioMeetingsList = function() {
  return /** @type{!Array<!proto.base.ActiveUserAudioMeeting>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.base.ActiveUserAudioMeeting, 4));
};


/**
 * @param {!Array<!proto.base.ActiveUserAudioMeeting>} value
 * @return {!proto.base.LoginAck} returns this
*/
proto.base.LoginAck.prototype.setActiveUserAudioMeetingsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.base.ActiveUserAudioMeeting=} opt_value
 * @param {number=} opt_index
 * @return {!proto.base.ActiveUserAudioMeeting}
 */
proto.base.LoginAck.prototype.addActiveUserAudioMeetings = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.base.ActiveUserAudioMeeting, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.base.LoginAck} returns this
 */
proto.base.LoginAck.prototype.clearActiveUserAudioMeetingsList = function() {
  return this.setActiveUserAudioMeetingsList([]);
};


/**
 * optional bool web_admin_mode = 5;
 * @return {boolean}
 */
proto.base.LoginAck.prototype.getWebAdminMode = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.base.LoginAck} returns this
 */
proto.base.LoginAck.prototype.setWebAdminMode = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * repeated string feature_flags = 6;
 * @return {!Array<string>}
 */
proto.base.LoginAck.prototype.getFeatureFlagsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.base.LoginAck} returns this
 */
proto.base.LoginAck.prototype.setFeatureFlagsList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.base.LoginAck} returns this
 */
proto.base.LoginAck.prototype.addFeatureFlags = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.base.LoginAck} returns this
 */
proto.base.LoginAck.prototype.clearFeatureFlagsList = function() {
  return this.setFeatureFlagsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.ResetAck.prototype.toObject = function(opt_includeInstance) {
  return proto.base.ResetAck.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.ResetAck} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.ResetAck.toObject = function(includeInstance, msg) {
  var f, obj = {
    creqId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    error: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.ResetAck}
 */
proto.base.ResetAck.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.ResetAck;
  return proto.base.ResetAck.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.ResetAck} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.ResetAck}
 */
proto.base.ResetAck.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreqId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.ResetAck.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.ResetAck.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.ResetAck} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.ResetAck.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCreqId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string creq_id = 1;
 * @return {string}
 */
proto.base.ResetAck.prototype.getCreqId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.ResetAck} returns this
 */
proto.base.ResetAck.prototype.setCreqId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string error = 2;
 * @return {string}
 */
proto.base.ResetAck.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.ResetAck} returns this
 */
proto.base.ResetAck.prototype.setError = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.SetProjectContext.prototype.toObject = function(opt_includeInstance) {
  return proto.base.SetProjectContext.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.SetProjectContext} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.SetProjectContext.toObject = function(includeInstance, msg) {
  var f, obj = {
    projectId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.SetProjectContext}
 */
proto.base.SetProjectContext.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.SetProjectContext;
  return proto.base.SetProjectContext.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.SetProjectContext} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.SetProjectContext}
 */
proto.base.SetProjectContext.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.SetProjectContext.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.SetProjectContext.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.SetProjectContext} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.SetProjectContext.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.base.SetProjectContext.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.SetProjectContext} returns this
 */
proto.base.SetProjectContext.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.SetProjectContextAck.prototype.toObject = function(opt_includeInstance) {
  return proto.base.SetProjectContextAck.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.SetProjectContextAck} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.SetProjectContextAck.toObject = function(includeInstance, msg) {
  var f, obj = {
    projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    error: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.SetProjectContextAck}
 */
proto.base.SetProjectContextAck.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.SetProjectContextAck;
  return proto.base.SetProjectContextAck.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.SetProjectContextAck} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.SetProjectContextAck}
 */
proto.base.SetProjectContextAck.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.SetProjectContextAck.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.SetProjectContextAck.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.SetProjectContextAck} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.SetProjectContextAck.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.base.SetProjectContextAck.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.SetProjectContextAck} returns this
 */
proto.base.SetProjectContextAck.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string error = 2;
 * @return {string}
 */
proto.base.SetProjectContextAck.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.SetProjectContextAck} returns this
 */
proto.base.SetProjectContextAck.prototype.setError = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


goog.object.extend(exports, proto.base);
